import type {CompetitorPlayersStatsModuleState} from "../../models/competitor-players-stats-module.state";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {CompetitorPlayerStatsModuleShotMapShotSwipeClickEventModel} from "../../models/analytics/competitor-player-stats.module.shot-map.shot-swipe-click.event.model";

export class CompetitorPlayerStatsModuleShotMapShotSwipeClickEventHandler extends AnalyticsEventHandler {
  state: CompetitorPlayersStatsModuleState;
  type: String = COMPETITOR_PLAYER_STATS.ACTION_TYPES.shotMapShotSwipeClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleShotMapShotSwipeClickEventModel;
  }
}